/* eslint no-useless-escape: 0 */

const ff = "Hands up for your force fields\nTwo thumbs up for cheap thrills\nNot sure which one your brain decides\nApproaching the line\nShowing zero vital signs\nMaybe they'll just wave you on by\nBut now I'm growing into these\nWings forged through victories\nStrapped to my back but time to fly\nSo let's fly...\nHonoring the signs\nOmens and Valentines\nA good way to meet your sweet demise\nBut not mine...";

export default ff;